<template>
	<div>
		
		<stato-fase
			:fase-with-stati="faseWithStati"
			:pratica="pratica"
			:pratica-diff="praticaDiff"
			@update-id-stato="pratica.id_stato_fase_5 = $event"
			:disabled="isLoading"
			:action="action"
		></stato-fase>
		
		<v-sheet
			rounded
			color="primary"
			class="my-5 px-4 mt-10 text-h6"
		>
			<span class="tertiary--text">
				Esito
			</span>
		</v-sheet>
		
		<v-row>
			<v-col>
				<template v-if="(action != 'show' && isAccountManager) || (isCliente && pratica.id_stato_fase_5 == 84)">
					<v-badge
						:value="haveFilesBeenModified.ricevuta_click_day"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-file-input
							v-model="files.ricevuta_click_day"
							label="PEC Esito"
							hide-details
							outlined
							dense
							clearable
							accept="application/pdf, image/png, image/jpeg, image/jpg"
							truncate-length="120"
							@change="setChanged(files.ricevuta_click_day)"
							@click:clear="pratica.path_ricevuta_click_day = null"
							:loading="isLoadingRicevutaClickDay"
							:disabled="isLoading"
						>
							<template
								v-slot:append
							>
								<template v-if="pratica.path_ricevuta_click_day !== null && !isLoadingRicevutaClickDay">
									<v-progress-circular
										v-if="downloadingRicevutaClickDay"
										size="24"
										width="3"
										color="primary"
										indeterminate
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="download(pratica.path_ricevuta_click_day, 'ricevuta_click_day')"
									>
										mdi-tray-arrow-down
									</v-icon>
								</template>
								<v-icon
									v-if="files.ricevuta_click_day !== null"
									class="ml-3"
									@click="viewFileInBrowser(files.ricevuta_click_day)"
								>
									mdi-eye-outline
								</v-icon>
							</template>
						</v-file-input>
					</v-badge>
				</template>
				
				<template v-else-if="action == 'show' || (isCliente && pratica.id_stato_fase_5 != 84)">
					<v-text-field
						:value="getFileNameFromPath(pratica.path_ricevuta_click_day)"
						label="PEC Esito"
						hide-details
						outlined
						dense
						readonly
					>
						<template
							v-slot:append
							v-if="pratica.path_ricevuta_click_day !== null"
						>
							<template>
								<template>
									<v-progress-circular
										v-if="downloadingRicevutaClickDay"
										size="24"
										width="3"
										color="primary"
										indeterminate
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="download(pratica.path_ricevuta_click_day, 'ricevuta_click_day')"
									>
										mdi-tray-arrow-down
									</v-icon>
								</template>
								<template>
									<v-progress-circular
										v-if="isGettingFile.ricevuta_click_day"
										size="24"
										width="3"
										color="primary"
										indeterminate
										class="ml-3"
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="getFileAndViewInBrowser(pratica.path_ricevuta_click_day, 'ricevuta_click_day')"
									>
										mdi-eye-outline
									</v-icon>
								</template>
								
							</template>
						</template>
					</v-text-field>
				</template>
				
				<div
					v-if="pratica.path_ricevuta_click_day && !isCliente"
					class="mt-2"
				>
					Ricevuta caricata il {{ getDateFromDateTime(pratica.data_ora_ricevuta) }}
				</div>
			</v-col>
		</v-row>
		
		<template v-if="(pratica.id_stato_fase_5 != 84 && isCliente) || isAccountManager || isCoordinatore">
			<v-row
				class="flex-column text-h6 mt-4"
				no-gutters
			>
				<v-col>
					Esito: <span class="primary--text">{{ esitoClickday }}</span>
				</v-col>
				<v-col>
					Tempo: <span class="primary--text">{{ tempoClickday }}</span>
				</v-col>
			</v-row>
		</template>
		
		<v-row>
			<v-col>
				<template v-if="action != 'show' && isAccountManager">
					<v-badge
						:value="haveFilesBeenModified.esito_rna"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-file-input
							v-model="files.esito_rna"
							label="Esito RNA"
							hide-details
							outlined
							dense
							clearable
							accept="application/pdf, image/png, image/jpeg, image/jpg"
							truncate-length="120"
							@change="setChanged(files.esito_rna)"
							@click:clear="pratica.path_esito_rna = null"
							:loading="isLoadingEsitoRNA"
							:disabled="isLoading"
						>
							<template
								v-slot:append
							>
								<template v-if="pratica.path_esito_rna !== null && !isLoadingEsitoRNA">
									<v-progress-circular
										v-if="downloadingEsitoRNA"
										size="24"
										width="3"
										color="primary"
										indeterminate
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="download(pratica.path_esito_rna, 'esito_rna')"
									>
										mdi-tray-arrow-down
									</v-icon>
								</template>
								<v-icon
									v-if="files.esito_rna !== null"
									class="ml-3"
									@click="viewFileInBrowser(files.esito_rna)"
								>
									mdi-eye-outline
								</v-icon>
							</template>
						</v-file-input>
					</v-badge>
				</template>
				
				<template v-else-if="action == 'show' && isAccountManager">
					<v-text-field
						:value="getFileNameFromPath(pratica.path_esito_rna)"
						label="Esito RNA"
						hide-details
						outlined
						dense
						readonly
					>
						<template
							v-slot:append
							v-if="pratica.path_esito_rna !== null"
						>
							<template>
								<v-progress-circular
									v-if="downloadingEsitoRNA"
									size="24"
									width="3"
									color="primary"
									indeterminate
								></v-progress-circular>
								<v-icon
									v-else
									class="ml-3"
									@click="download(pratica.path_esito_rna, 'esito_rna')"
								>
									mdi-tray-arrow-down
								</v-icon>
							</template>
							<template>
								<v-progress-circular
									v-if="isGettingFile.esito_rna"
									size="24"
									width="3"
									color="primary"
									indeterminate
									class="ml-3"
								></v-progress-circular>
								<v-icon
									v-else
									class="ml-3"
									@click="getFileAndViewInBrowser(pratica.path_esito_rna, 'esito_rna')"
								>
									mdi-eye-outline
								</v-icon>
							</template>
						</template>
					</v-text-field>
				</template>
			</v-col>
		</v-row>
		
		<v-row v-if="isAccountManager">
			<v-col cols="6">
				<v-badge
					:value="praticaDiff.includes('esito_clickday_manuale')"
					class="d-block"
					color="info"
					overlap
					right
					icon="mdi-pencil"
				>
					<v-select
						:items="esitiManualiClickday"
						v-model="pratica.esito_clickday_manuale"
						label="Esito Manuale Pratica"
						outlined
						dense
						clearable
						:readonly="action == 'show'"
					></v-select>
				</v-badge>
			</v-col>
		</v-row>
		
		<template v-if="(isAccountManager || isCliente) && (pratica.id_stato_fase_5 != 84 || pratica.esito_clickday_manuale == 'Vincente Esiti Definitivi')">
			<v-sheet
				rounded
				color="primary"
				class="my-5 px-4 mt-10 text-h6"
			>
				<span class="tertiary--text">
					Imponibili da fatturare in base all'esito
				</span>
			</v-sheet>
			
			<v-row>
				<v-col cols="6">
					<v-badge
						:value="praticaDiff.includes('importo_da_fatturare_esiti_definitivi')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.importo_da_fatturare_esiti_definitivi"
							@input="pratica.importo_da_fatturare_esiti_definitivi = $event !== '' ? $event : null"
							label="Imponibile da Fatturare"
							outlined
							dense
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
							type="number"
							min="0"
							:rules="[mixin_rules.min0]"
						></v-text-field>
					</v-badge>
				</v-col>
			</v-row>
			
			<!--
				Al momento questi campi sono nascosti ai clienti.
				Se si decidesse di mostrarli, devo renderli visibili solo se
				path_accordo_prenotazione != null || is_partner
			-->
			<template v-if="isAccountManager || isConsulente || isAssociazioneDiCategoria">
				<v-sheet
					rounded
					color="primary"
					class="my-5 px-4 mt-10 text-h6"
				>
				<span class="tertiary--text">
					Imponibili bonus in base all'esito
				</span>
				</v-sheet>
				
				<v-row>
					<v-col cols="6">
						<v-badge
							:value="praticaDiff.includes('importo_bonus_esiti_definitivi')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-text-field
								:value="pratica.importo_bonus_esiti_definitivi"
								@input="pratica.importo_bonus_esiti_definitivi = $event !== '' ? $event : null"
								label="Imponibile Bonus"
								outlined
								dense
								:readonly="action == 'show' || !isAccountManager"
								:disabled="isLoading"
								:persistent-placeholder="isCliente"
								type="number"
								min="0"
								:rules="[mixin_rules.min0]"
							></v-text-field>
						</v-badge>
					</v-col>
				</v-row>
			</template>
			
			<template v-if="isAccountManager">
				<v-row>
					<v-col cols="6">
						<v-btn
							color="secondary"
							@click="calcoloAutomaticoImporti('esiti_definitivi')"
							:disabled="isLoading
								|| pratica.contratto_di_servizio_id === null
								|| pratica.contratto_di_servizio?.tipo_contratto_di_servizio_id === null
								|| (esitoClickday != 'Vincente Esiti Definitivi'
								&& pratica.esito_clickday_manuale != 'Vincente Esiti Definitivi')"
						>
							Calcola imponibili {{ pratica.esito_clickday_manuale == 'Vincente Esiti Definitivi' ? '(Esito Manuale Pratica impostato)' : ''}}
						</v-btn>
					</v-col>
					<v-col cols="12">
						<p
							v-if="pratica.contratto_di_servizio_id === null || pratica.contratto_di_servizio?.tipo_contratto_di_servizio_id === null"
							:style="`color:${$vuetify.theme.currentTheme.warning}`"
						>
							Il bottone per il calcolo automatico dell'imponibile non è disponibile,<br>
							assicurati che sia stato associato un Contratto di Servizio e sia stato scelto il Tipo di Contratto di Servizio
						</p>
						<p
							v-else-if="pratica.esito_clickday_manuale != 'Vincente Esiti Definitivi' && esitoClickday != 'Vincente Esiti Definitivi'"
							:style="`color:${$vuetify.theme.currentTheme.warning}`"
						>
							Il bottone per il calcolo automatico dell'imponibile non è disponibile perché l'esito non è vincente.
						</p>
					</v-col>
				</v-row>
			</template>
		</template>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/event-bus";
export default {
	props: ['value', 'action', 'faseWithStati', 'praticaDiff', 'haveFilesBeenModified'],
	data() {
		return {
			pratica: {
				id: null,
				id_stato_fase_5: null,
				ci_sono_aggiornamenti_fase_5: false,
				path_ricevuta_click_day: null,
				path_esito_rna: null
			},
			files: {
				ricevuta_click_day: null,
				esito_rna: null
			},
			isLoadingRicevutaClickDay: false,
			downloadingRicevutaClickDay: false,
			
			isLoadingEsitoRNA: false,
			downloadingEsitoRNA: false,
			
			esitiManualiClickday: [
				'Iscritto',
				'In attesa di esito',
				'Vincente Esiti Provvisori',
				'Non vincente',
				'Abbandonato / Screenshot mancante',
				'Non assegnato',
				'Vincente Esiti Definitivi',
				'Riserva',
				'Recesso',
				'Sostituito da Riserva'
			]
		}
	},
	
	created() {
		this.isSettingPratica = true;
		// this.pratica = Object.assign({}, this.value);
		this.pratica = this.value;
		this.isSettingPratica = false;
		
		if (this.pratica.ci_sono_aggiornamenti_fase_5 && this.isCliente) {
			this.pratica.ci_sono_aggiornamenti_fase_5 = false;
			this.$emit('input', this.pratica);
			this.$emit('aggiornamenti-visualizzati', {
				praticaId: this.pratica.id,
				aggiornamentoKey: 'ci_sono_aggiornamenti_fase_5',
				aggiornamentoValue: false
			});
			this.salvaAggiornamentiVisualizzati(this.pratica.id, 'ci_sono_aggiornamenti_fase_5');
		}
		
		if (this.pratica.path_ricevuta_click_day !== null && (this.action != 'show' && this.isAccountManager)) {
			this.getRicevutaClickDay();
		}
		
		if (this.pratica.path_esito_rna !== null && (this.action != 'show' && this.isAccountManager)) {
			this.getEsitoRNA();
		}
	},
	
	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente',
			isCoordinatore: 'auth/isCoordinatore',
			isConsulente: 'auth/isConsulente',
			isAssociazioneDiCategoria: 'auth/isAssociazioneDiCategoria'
		}),
		isLoading() {
			return this.isSettingPratica;
		},
		esitoClickday() {
			if (this.pratica.cliccatore_id !== null) {
				return this.pratica.cliccatore.bandi_simulatore[0]?.esito_bando.esito_clickday;
			}
			else return null;
		},
		tempoClickday() {
			if (this.pratica.cliccatore_id !== null) {
				return this.pratica.cliccatore.bandi_simulatore[0]?.esito_bando.tempo_clickday;
			}
			else return null;
		}
	},
	
	watch: {
		pratica: {
			handler(newPratica) {
				if (!this.isLoading) {
					this.$emit('input', newPratica)
				}
			},
			deep: true
		},
		files: {
			handler(newFiles) {
				if (!this.isLoading) {
					this.$emit('update-files', newFiles)
				}
			},
			deep: true
		},
		isLoading(newVal) {
			this.$emit('is-loading', newVal)
		},
	},
	
	methods: {
		calcoloAutomaticoImporti(key) {
			axios.post('/api/tipi-contratto-di-servizio/calcolo-importi', {
				pratica_id: this.pratica.id,
				tipo_contratto_di_servizio_id: this.pratica.contratto_di_servizio.tipo_contratto_di_servizio_id
			})
				.then(response => {
					if (key == 'esiti_provvisori') {
						this.pratica.importo_da_fatturare = response.data.importo_fattura;
						this.pratica.importo_bonus_esiti_provvisori = response.data.importo_bonus;
					}
					else if (key == 'esiti_definitivi') {
						this.pratica.importo_da_fatturare_esiti_definitivi = response.data.importo_fattura;
						this.pratica.importo_bonus_esiti_definitivi = response.data.importo_bonus;
					}
				})
		},
		async getRicevutaClickDay() {
			this.isLoadingRicevutaClickDay = true;
			this.files.ricevuta_click_day = await this.getFile(this.pratica.path_ricevuta_click_day);
			this.files.ricevuta_click_day.changed = false;
			this.isLoadingRicevutaClickDay = false;
		},
		async getEsitoRNA() {
			this.isLoadingEsitoRNA = true;
			this.files.esito_rna = await this.getFile(this.pratica.path_esito_rna);
			this.files.esito_rna.changed = false;
			this.isLoadingEsitoRNA = false;
		},
		download(path, key) {
			const fileName = this.getFileNameFromPath(path);
			if (key == 'ricevuta_click_day') this.downloadingRicevutaClickDay = true;
			else if (key == 'esito_rna') this.downloadingEsitoRNA = true;
			axios.post('/api/storage/download',
				{
					path: path
				},
				{
					responseType: 'blob'
				})
				.then(response => {
					saveAs(response.data, fileName);
				})
				.finally(() => {
					if (key == 'ricevuta_click_day') this.downloadingRicevutaClickDay = false;
					else if (key == 'esito_rna') this.downloadingEsitoRNA = false;
				})
		},
		setChanged(file) {
			if (file !== null && !this.isLoading) file.changed = true;
		},
		viewFileInBrowser(file) {
			const fileURL = URL.createObjectURL(file);
			window.open(fileURL);
		},
	}
}
</script>

<style scoped>

</style>